import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Formsy from "formsy-react";
import { Input } from "formsy-react-components";
import { Row } from "react-bootstrap";

class ForgotForm extends Component {
  constructor(props) {
    super(props);
    this.state = { canSubmit: false };
  }

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  submit = (model) => {
    this.props.onSave(model);
  };

  render() {
    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="forgot form"
        onValidSubmit={this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <h1>Forgot Password</h1>
        <Input
          formNoValidate
          required
          name="email"
          placeholder="Email"
          value=""
        />
        <Row className="text-center footer">
          <Link className="btn  btn-cancel" to="/">
            Cancel
          </Link>
          <input
            className="btn  btn-success"
            type="submit"
            disabled={!this.state.canSubmit}
            value={this.props.saving ? "Submitting... " : "Submit"}
          />
        </Row>
      </Formsy>
    );
  }
}

ForgotForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default ForgotForm;
